import React from "react";
import { Button } from "@/components/ui/button";
import { Pause, Play, CircleNotch, Lightning } from "@phosphor-icons/react";

export const DesignProgress = ({ p, onToggle, busy }) => {
  const pct = p.total ? Math.round((p.ready / p.total) * 100) : 0;
  const running = p.backfill_enabled && p.pending > 0;
  return (
    <div className="rounded-sm border border-slate-800 bg-slate-900/50 p-5" data-testid="designs-progress">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="text-xs tracking-widest text-slate-400 font-mono-num">IMAGE CONVERSION</div>
          <div className="font-mono-num text-3xl font-black text-slate-100 mt-1" data-testid="designs-progress-count">
            {p.ready} / {p.total} <span className="text-base font-bold text-slate-400">designs ready</span>
          </div>
          <div className="text-xs text-slate-400 mt-1 flex flex-wrap items-center gap-x-3 gap-y-1">
            {running && <CircleNotch size={12} className="animate-spin text-orange-400" />}
            <span data-testid="designs-progress-pending">Pending: {p.pending}</span>
            <span className="text-red-400" data-testid="designs-progress-failed">Failed: {p.failed}</span>
            {p.invalid > 0 && <span data-testid="designs-progress-invalid">Library se bahar (DXF nahi): {p.invalid}</span>}
            <span data-testid="designs-progress-lens">Lens ready: {p.lens_indexed}</span>
            {!p.backfill_enabled && <span className="text-amber-300">· PAUSED</span>}
          </div>
          {running && (
            <div className="text-xs text-emerald-300 mt-1 flex items-center gap-1" data-testid="designs-progress-speed">
              <Lightning size={12} weight="fill" /> {p.workers} files ek saath · {p.per_min || 0} files/min
              {p.eta_min != null && <> · lagbhag {p.eta_min} min baaki</>}
            </div>
          )}
        </div>
        <Button variant="outline" size="sm" disabled={busy} onClick={onToggle}
          className="rounded-sm border-slate-700 bg-slate-950" data-testid="designs-backfill-toggle">
          {p.backfill_enabled ? <><Pause size={14} className="mr-1" /> PAUSE</> : <><Play size={14} className="mr-1" /> RESUME</>}
        </Button>
      </div>
      <div className="h-2 mt-4 rounded-full bg-slate-800 overflow-hidden">
        <div className="h-full bg-orange-500 transition-[width] duration-700" style={{ width: `${pct}%` }} data-testid="designs-progress-bar" />
      </div>
    </div>
  );
};
